import React, { useState } from 'react';
import ExpandedEntityRow from './ExpandedEntityRow';

interface IRowProps {
  data: any;
}

const ExpandedPEPCountryRow: React.FC<IRowProps> = ({ data }) => {
  const [ isExpanded, setIsExpanded ] = useState(false);
  return (
    <>
      <div className='second-row'>
        <div
          className='sr-icon-cell'
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className='sr-icon-frame'>
            <div className='sr-icon-svg'>
              {!isExpanded ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='8'
                  height='12'
                  viewBox='0 0 8 12'
                  fill='none'
                >
                  <path
                    d='M0.8421 1.70175C0.643269 1.51462 0.543853 1.2807 0.543853 1C0.543853 0.719297 0.643269 0.48538 0.8421 0.298246C1.02923 0.0994158 1.26315 -3.14415e-08 1.54385 -4.37114e-08C1.82455 -5.59813e-08 2.05847 0.0994157 2.24561 0.298246L7.14034 5.19298C7.35087 5.40351 7.45613 5.67251 7.45613 6C7.45613 6.31579 7.35087 6.58479 7.14034 6.80702L2.24561 11.7018C2.05847 11.9006 1.82456 12 1.54385 12C1.26315 12 1.02923 11.9006 0.8421 11.7018C0.64327 11.5029 0.543854 11.269 0.543854 11C0.543854 10.7076 0.643269 10.4737 0.8421 10.2982L5.73684 5.40351C5.79532 5.34503 5.83625 5.43275 5.85964 5.66667C5.88303 5.88889 5.88303 6.11696 5.85964 6.35088C5.83625 6.5731 5.79532 6.65497 5.73684 6.59649L0.8421 1.70175Z'
                    fill='var(--alternative-text-color)'
                  />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='12'
                  height='8'
                  viewBox='0 0 12 8'
                  fill='none'
                >
                  <path
                    d='M10.2982 0.841215C10.4854 0.642385 10.7193 0.542969 11 0.542969C11.2807 0.542969 11.5146 0.642385 11.7018 0.841215C11.9006 1.02835 12 1.26227 12 1.54297C12 1.82367 11.9006 2.05759 11.7018 2.24472L6.80702 7.13946C6.59649 7.34999 6.32749 7.45525 6 7.45525C5.68421 7.45525 5.41521 7.34999 5.19298 7.13946L0.298246 2.24472C0.0994153 2.05759 0 1.82367 0 1.54297C0 1.26227 0.0994153 1.02835 0.298246 0.841215C0.497076 0.642385 0.730994 0.542969 1 0.542969C1.2924 0.542969 1.52632 0.642385 1.70175 0.841215L6.59649 5.73595C6.65497 5.79443 6.56725 5.83537 6.33333 5.85876C6.11111 5.88215 5.88304 5.88215 5.64912 5.85876C5.4269 5.83537 5.34503 5.79443 5.40351 5.73595L10.2982 0.841215Z'
                    fill='var(--alternative-text-color)'
                  />
                </svg>
              )}
            </div>
          </div>
        </div>
        <div className='sr-primary-col'>
          <div className='sr-primary-header'>
            <div className='sr-primary-header-typo'>{data.key}</div>
          </div>
        </div>
        <div className='sr-end-col'>
          <div className='sr-end-header'>
            <div className='sr-end-header-typo'>{data.doc_count}</div>
          </div>
        </div>
      </div>
      {isExpanded &&
        data.typeAgg.buckets.map((type: any, index: number) => (
          <ExpandedEntityRow key={index} data={type} />
        ))}
    </>
  );
};

export default ExpandedPEPCountryRow;
